<template lang="pug">
  .input_container
    label.container_radio(v-for="option in options")
      | {{option.label}}
      input(type='radio' :value="option.value" :name="name" :checked="option.value == defaultValue"  @input="returnValue")
      span.checkmark
</template>
<script>
export default {
  props: ['options', 'defaultValue', 'name'],
  methods: {
    returnValue() {
      if (event.target.value === '') {
        this.$emit('input', null)
      } else {
        this.$emit('input', event.target.value)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.container_radio
  display: inline-block
  position: relative
  padding-left: 40px
  padding-top: 2px
  padding-bottom: 6px
  cursor: pointer
  font-size: 17px
input
  position: absolute
  opacity: 0
  cursor: pointer
  height: 0
  width: 0
.checkmark
  position: absolute
  top: 0
  left: 8px
  height: 25px
  width: 25px
  background: #ebf7f9
  border-radius: 50%
.checkmark:hover
  transition: all, 0.1s
  background: #c3e6ee
input:checked ~ .checkmark
  background: #2793a7
.checkmark:after
  content: ""
  position: absolute
  display: none
input:checked ~ .checkmark:after
  display: block
.checkmark:after
  top: 9px
  left: 9px
  width: 8px
  height: 8px
  border-radius: 50%
  background: white
</style>
